// Sprint B (admin DA-2) — predicates for the new auto-expiry events that
// the backend cron emits. Mirrors the storefront's utils/orderHelpers but
// tailored for the admin's edge case: a Paymob webhook landing AFTER the
// pending-orders sweep cancelled the order. The customer paid, the order
// is cancelled, and an admin needs to issue a refund manually.

/**
 * True when the order's timeline contains a `payment.received_after_expiry`
 * event — emitted by the backend when a webhook confirms payment after the
 * order was already auto-cancelled.
 */
export const hasLatePaymentRefundEvent = (events) => {
    if (!Array.isArray(events)) return false;
    return events.some((e) => e?.event === 'payment.received_after_expiry');
};

/**
 * True when the order needs an admin-issued refund: cancelled, has a
 * completed payment recorded against it, AND has the late-payment event.
 * All three conditions must hold — a vanilla cancellation with no payment
 * is just a no-op and a paid+delivered order isn't a refund target.
 */
export const needsLatePaymentManualRefund = (order, events) => {
    if (!order || order.status !== 'cancelled') return false;
    if (!hasLatePaymentRefundEvent(events)) return false;
    const payments = Array.isArray(order.payments) ? order.payments : [];
    return payments.some((p) =>
        ['paid', 'completed', 'partially_refunded'].includes(p?.status)
    );
};
